import { useDeparturesStepContext } from "../context/DeparturesStepContext";
import { Checkbox } from "@wojo/ui";
import { gtmSendEvent } from "@wojo/analytics";

type DepartureHeaderFeaturedFilterProps = {
    label: string;
    filterName: string;
    filterType: string;
};

export const DepartureHeaderFeaturedFilter: React.FC<
    DepartureHeaderFeaturedFilterProps
> = ({ label, filterName, filterType }) => {
    const { filterStates, setFilterStates } = useDeparturesStepContext();

    return (
        <div
            style={{
                display: "grid",
                gap: "var(--g-spacing-md)",
            }}
        >
            <Checkbox
                label={label}
                checked={filterStates.filters?.includes(filterName) ?? false}
                onChange={async (e) => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "FILTERED",
                            filterType,
                            isSelected: `${e.target.checked}`,
                        },
                    });
                    //if the checkbox is checked, add the filter to the list of filters, else remove it
                    const filters = e.target.checked
                        ? [...(filterStates.filters ?? []), filterName]
                        : filterStates.filters?.filter(
                              (f: string) => f !== filterName,
                          );
                    await setFilterStates({
                        filters: filters?.length ? filters : null,
                    });
                }}
            />
        </div>
    );
};
